define('ScrollReveal.EntryPoint', ['ScrollReveal'], function ScrollRevealEntryPoint(ScrollReveal) {
	'use strict';

	return {
		mountToApp: function mountToApp(container) {
			var layout = container.getComponent('Layout');

			if (!layout) {
				return;
			}

			// SuiteCommerce is a SPA: content is re-rendered on every navigation.
			// afterShowContent fires once the current view DOM is ready.
			layout.on('afterShowContent', function onAfterShowContent() {
				ScrollReveal.init();
			});
		}
	};
});
